// extracted by mini-css-extract-plugin
export default {"container":"bY-z","title":"cY-z","link":"dY-z"};